<template>
  <VaLayout class="h-screen bg-[var(--va-background-secondary)]">
    <template #content>
      <div class="auth-layout">
        <main class="auth-layout__main">
          <RouterView />
        </main>
        <!-- <AppFooter /> -->
      </div>
    </template>
  </VaLayout>
</template>

<script lang="ts" setup></script>

<style scoped>
.auth-layout {
  min-height: 100vh;
  width: 100%;
  display: flex;
  flex-direction: column;
}

.auth-layout__main {
  flex: 1;
  display: flex;
  align-items: stretch;
  justify-content: stretch;
  width: 100%;
  min-height: 100vh;
}
</style>
